import axios from "axios";

export const state = {
    requirementcategory: [],
};

export const getters = {
    requirementcategory: state => state.requirementcategory,
};

export const mutations = {
    setRequirementcategory(state, newValue) {
        state.requirementcategory = newValue
    },
};

export const actions = {
    fetchRequirementcategory({ commit }) {
        axios.get('/requirementcategory').then(res => {
            commit('setRequirementcategory', res.data.units)
        })
    },
};